import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import api from 'services/api';
import Snackbar from 'components/Snackbar';
import Card from 'components/Card';

const listContainerStyles = {
  flexDirection: 'column',
  maxWidth: '1200px',
  width: '100%',
};

const cardContentStyles = {
  display: 'grid',
  gridTemplateColumns: 'minmax(240px, 1fr) 160px 150px 150px',
  alignItems: 'center',
  columnGap: '24px',
  minHeight: '48px',
};

const cardContentResponsiveStyles = {
  '@media (max-width: 900px)': {
    gridTemplateColumns: '1fr 1fr',
    rowGap: '12px',
  },
  '@media (max-width: 600px)': {
    gridTemplateColumns: '1fr',
  },
};

function AdherenceDriverReport() {
  const params = useParams();
  const [loadingInterestedDrivers, setLoadingInterestedDrivers] = useState(true);
  const [interestedDrivers, setInterestedDrivers] = useState([]);
  const [textNotFound, setTextNotFound] = useState('');
  const [snackBar, setSnackBar] = useState({
    display: false,
    type: 'error',
    message: '',
    duration: 5000,
  });

  async function getInterestedDrivers() {
    setLoadingInterestedDrivers(true);
    try {
      const response = await api.get(`adherence/visualizations/${params.load_id}`);
      if (response.status === 200) {
        if (response.data.length === 0) {
          setTextNotFound('Nenhum motorista encontrado');
          setInterestedDrivers([]);
          return;
        }
        setInterestedDrivers(response.data);
      }
    } catch (error) {
      setTextNotFound('Não foi possível obter os motoristas.');
      setSnackBar({
        display: true,
        type: 'error',
        message: 'Não foi possível obter os motoristas interessados.',
        duration: 10000,
      });
    } finally {
      setLoadingInterestedDrivers(false);
    }
  }

  useEffect(() => {
    getInterestedDrivers();
  }, []);

  return (
    <>
      <Snackbar
        open={snackBar.display}
        type={snackBar.type}
        message={snackBar.message}
        duration={snackBar.duration}
        onClose={() => setSnackBar(false)}
      />

      <Typography variant="body1" sx={{ color: '#76838F', mb: 1 }}>
        Dados da carga: {params.load_id}
      </Typography>

      <Grid container spacing={2} sx={listContainerStyles}>
        {interestedDrivers.length ? (
          interestedDrivers.map((driver) => (
            <Grid item xs={12} key={driver.username} sx={{ width: '100%' }}>
              <Card
                style={{
                  marginTop: '25px',
                  overflow: 'visible',
                }}
                bordered={1}
                borderhexcolor={driver.interested ? '#00bc97' : '#f44336'}
              >
                <Grid sx={{ ...cardContentStyles, ...cardContentResponsiveStyles }}>
                  <div>
                    <Typography variant="caption" gutterBottom>
                      NOME
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      <strong>{driver.username}</strong>
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="caption" gutterBottom>
                      TELEFONE
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      <strong>{driver.phonenumber}</strong>
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="caption" gutterBottom>
                      VISUALIZAÇÕES
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      <strong>{driver.quantity}</strong>
                    </Typography>
                  </div>
                  <div>
                    <Typography variant="caption" gutterBottom>
                      INTERESSOU ?
                    </Typography>
                    <Typography
                      variant="body2"
                      gutterBottom
                      sx={{ color: driver.interested ? '#00bc97' : '#f44336' }}
                    >
                      <strong>{driver.interested ? 'Sim' : 'Não'}</strong>
                    </Typography>
                  </div>
                </Grid>
              </Card>
            </Grid>
          ))
        ) : loadingInterestedDrivers ? (
          [...Array(5)].map((_, i) => (
            <Grid item xs={12} key={i} sx={{ width: '100%' }}>
              <Skeleton variant="rectangular" height={120} />
            </Grid>
          ))
        ) : (
          <Grid item xs={12} sx={{ width: '100%' }}>
            <Card
              style={{
                marginTop: '40px',
                overflow: 'visible',
              }}
              bordered={1}
              borderhexcolor="#f44336"
            >
              <Grid container spacing={1} sx={{ my: 1 }}>
                <Grid item xs={12}>
                  <Typography variant="h6">{textNotFound}</Typography>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        )}
      </Grid>
    </>
  );
}

export default AdherenceDriverReport;
